import React__default from 'react';
import classNames from 'classnames';
var HamburgerButton = function HamburgerButton(_ref) {
  var isOpen = _ref.isOpen,
    onToggleMenu = _ref.onToggleMenu;
  var buttonTitle = isOpen ? "Fechar menu" : "Abrir menu";
  var componentClass = classNames("header-cp__hamburger", {
    "header-cp__hamburger--close": !!isOpen
  });
  return /* @__PURE__ */React__default.createElement("button", {
    className: componentClass,
    onClick: onToggleMenu,
    "aria-label": buttonTitle
  }, /* @__PURE__ */React__default.createElement("div", {
    className: "header-cp__hamburger-line header-cp__hamburger-line--one"
  }), /* @__PURE__ */React__default.createElement("div", {
    className: "header-cp__hamburger-line header-cp__hamburger-line--two"
  }), /* @__PURE__ */React__default.createElement("div", {
    className: "header-cp__hamburger-line header-cp__hamburger-line--three"
  }));
};
export { HamburgerButton as default };